export const MAIN_SUBDOMAINS = ['www', 'dev', 'staging', '', 'localhost'];

export function resolveRootMode(hostname) {
    const subdomain = hostname.split('.')[0] || '';
    const isNumericSubdomain = /^\d+$/.test(subdomain);
    const isMainSubdomain = MAIN_SUBDOMAINS.includes(subdomain) || isNumericSubdomain;

    if (subdomain === 'fm') return {rootMode: 'fm', subdomain};
    if (!isMainSubdomain) return {rootMode: 'vanity', subdomain};
    return {rootMode: 'main', subdomain};
}
